import { render, staticRenderFns } from "./GenericBackground.vue?vue&type=template&id=49341899"
import script from "./GenericBackground.vue?vue&type=script&setup=true&lang=js"
export * from "./GenericBackground.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports